// import logo from './logo.svg';
import styles from './css/app.module.css';
import CheckOutScreen from './pages/checkOutScreen';
import Reports from './pages/reports';
import PDFFile from './components/PDFFile';
import TicketHeroPage from './pages/ticketEntry';
import SearchPage from './pages/searchPage';
import InTicketsReport from './components/InTicketsReport';
import ClosedTicketsReport from './components/OutTicketsReport';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import AppProvider, { AppContext } from './store/context/context';
import Login from './pages/userLogin';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useContext } from 'react';
import Dashboard from './pages/dashboard';
import MainPage from './pages/mainPage';
import UpdatedReports from './pages/updatedReports';
import ReportDisplay from './components/reportDisplay';
import TopDashboard from './components/TopDashboard';
import UpdatedDash from './components/updatedDash';
import ManualTicketsRemoval from './pages/ManualTicketsRemoval';
import CloseTicketScreen from './components/CloseTicketScreen';

// function useOnlineStatus() {
//   const [isOnline, setIsOnline] = useState(true);

//   useEffect(() => {
//     const handleOnline = () => {
//       setIsOnline(true);
//     };
//     const handleOffline = () => {
//       setIsOnline(false);
//     };

//     window.addEventListener('online', handleOnline);
//     window.addEventListener('offline', handleOffline);

//     return () => {
//       window.removeEventListener('online', handleOnline);
//       window.removeEventListener('offline', handleOffline);
//     };
//   }, []);

//   return isOnline;
// }

function App() {
  function MainScreen() {
    const logInContext = useContext(AppContext);
    // const isOnline = useOnlineStatus();
    return (
      <div className={styles.mainContainer}>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={true}
          draggable={true}
          pauseOnHover={true}
        />

        {!logInContext.isAuth && localStorage.getItem('isAuth') !== 'true' ? (
          <Login />
        ) : (
          <header className="App-header">
            <Navbar />
            {/* <Sidebar /> */}
            {/* <div>
              <h3
                style={{
                  color: 'white',
                  display: isOnline ? 'block' : 'none',
                  position: 'absolute',
                  top: 80,
                  right: 10,
                }}
              >
                Network Status: Online
              </h3>
              <h3 style={{ color: 'white', display: !isOnline ? 'block' : 'none' }}>Network Status: Offline</h3>
            </div> */}
            <Routes>
              <Route path="/userLogin" element={<Login />} />
              <Route path="/" element={<MainPage />} />
              <Route path="/ticketEntry" element={<TicketHeroPage />} />
              <Route path="/checkOutScreen" element={<CheckOutScreen />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/updatedReports" element={<UpdatedReports />} />
              <Route path="/reportDisplay" element={<ReportDisplay />} />
              <Route path="/PDFFile" element={<PDFFile />} />
              <Route path="/searchPage" element={<SearchPage />} />
              <Route path="/OutTicketsReport" element={<ClosedTicketsReport />} />
              <Route path="/inTicketsReport" element={<InTicketsReport />} />
              <Route path="/ManualTicketsRemoval" element={<ManualTicketsRemoval />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/TopDashboard" element={<TopDashboard />} />
              <Route path="updatedDash" element={<UpdatedDash />} />
              <Route path="CloseTicketScreen" element={<CloseTicketScreen />} />
            </Routes>
          </header>
        )}
      </div>
    );
  }

  return (
    <AppProvider>
      <MainScreen />
    </AppProvider>
  );
}

export default App;
